export const locale = {
    lang: 'es',
    data: {
        CHECKLIST: {
            ADD: {
                TITLE: 'NUEVO CHECKLIST'
            }
        }
    }
};
